module.exports = __webpack_public_path__ + "static/favicon-072d631fa7f8d2342a8e457cd8e1bec9.ico";